export default function HomeFAQ() {
  const faqs = [
    {
      q: '樱花漫画网上的漫画都是免费的吗？',
      a: '是的！樱花漫画网上所有漫画全集均提供免费完整版阅读。我们致力于为漫画爱好者打造一个无需付费即可畅享全本漫画的平台，涵盖韩漫、日漫、国漫等各种类型的好看漫画。',
    },
    {
      q: '什么是下拉式阅读？',
      a: '下拉式阅读是一种专为手机和网页优化的漫画阅读方式。您只需向下滑动页面即可连续阅读漫画全集，无需翻页点击，阅读体验更加流畅自然。樱花漫画网全站采用下拉式阅读模式，让您一次看个够。',
    },
    {
      q: '樱花漫画网有哪些漫画类型？',
      a: '我们提供三大类漫画：韩漫（韩国漫画，如《我独自升级》、《剑尊归来》）、日漫（日本漫画，如《咒术回战》、《鬼灭之刃》）、国漫（国产漫画，如《一人之下》、《镖人》），涵盖热血、恋爱、武侠、奇幻、电竞等多种题材的好看的漫画。',
    },
    {
      q: '漫画更新频率如何？',
      a: '樱花漫画网紧追各大漫画平台更新进度，热门连载漫画一般会在官方更新后24小时内同步。您可以在「最近更新」栏目中查看最新上架的漫画全集章节。',
    },
    {
      q: '如何找到我想看的漫画？',
      a: '您可以通过首页的分类导航（韩漫、日漫、国漫）浏览对应类型的漫画，也可以查看「热门推荐」和「人气排行」发现好看的漫画。进入漫画大全页面可以浏览全部上架的漫画全集。',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-5 rounded-full bg-primary-500"></div>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5"
            >
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}